export const TOGGLE_TERMS = 'TOGGLE_TERMS';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_CONNECTIONS = 'GET_CONNECTIONS';
export const TOGGLE_ACCOUNT_MAPPING = 'TOGGLE_ACCOUNT_MAPPING';
export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR';
export const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';
export const SET_LOGGEDIN_USER = 'SET_LOGGEDIN_USER';
export const FETCH_AGREEMENTS = 'FETCH_AGREEMENTS';
export const SIGNED_AGREEMENT = 'SIGNED_AGREEMENT';
export const LOAD_TERMS_CONDITIONS = 'LOAD_TERMS_CONDITIONS';
export const SHOW_SUCCESS_BAR = 'SHOW_SUCCESS_BAR';
export const RESET_PAGE_SIZE = 'RESET_PAGE_SIZE';
export const RESET_SNACK_BAR = 'RESET_SNACK_BAR';
export const SHOW_DANGER_BAR = 'SHOW_DANGER_BAR';
export const UPDATE_USER_NAME = 'UPDATE_USER_NAME';
export const UPDATE_PAGE_NAME = 'UPDATE_PAGE_NAME';
export const UPDATE_ACCOUNT_ID = 'UPDATE_ACCOUNT_ID';
export const UPDATE_DASHBOARD_URL = 'UPDATE_DASHBOARD_URL';
export const UPDATE_SIDEBAR_RESOURCE = 'UPDATE_SIDEBAR_RESOURCE';
export const SET_SESSION_VALUES = 'SET_SESSION_VALUES';
export const UPDATE_SESSION_VALUES = 'UPDATE_SESSION_VALUES';
export const CLEAR_SESSION_VALUES = 'CLEAR_SESSION_VALUES';
export const ENABLE_HEADER_OPERATIONS = 'ENABLE_HEADER_OPERATIONS';
export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE';
export const FETCH_AGREEMENTS_SIGNED_LOADED = 'FETCH_AGREEMENTS_SIGNED_LOADED';
export const GET_ACCOUNT_BY_ID = 'GET_ACCOUNT_BY_ID';
export const GET_SHARING_AGREEMENTS = 'GET_SHARING_AGREEMENTS';
export const GET_SHARING_AGREEMENTS_ORDERED = 'GET_SHARING_AGREEMENTS_ORDERED';
export const GET_ALL_VISIBILITY_SHARING_AGREEMENTS = 'GET_ALL_VISIBILITY_SHARING_AGREEMENTS';
export const GET_PROVIDER_INFORMATION = 'GET_PROVIDER_INFORMATION';
export const AGREEMENT_TOGGLE_SPINNER = 'AGREEMENT_TOGGLE_SPINNER';
